
    /*global server */
    import { defineComponent } from 'vue';
    import { useUserStore } from './../../stores/user';
    import { AxiosError, AxiosResponse } from 'axios';

    export default defineComponent({
        components: {

        },
        data() {
            const userStore = useUserStore();

            return {
                userStore,
                isPageLoading: false,
                pastPayments: [] as any,
            }
        },
        methods: {
            getPayments() {
                this.isPageLoading = true;
                var email = this.userStore?.user?.EmailAddress;
                this.$axios.get('payment/GetPayments', {
                    params: {
                        userEmail: email
                    }
                })
                    .then(({ data }: AxiosResponse<server.PastPayment[]>) => {
                        if (data.length > 0) {
                            this.pastPayments = data;
                        }
                    })
                    .catch((error: AxiosError) => {
                        console.log(error);
                    })
                    .finally(() => {
                        this.isPageLoading = false;
                    });
            },

            printReceiptReport(paymentID: number) {
                this.$router.push({
                    name: 'receiptReport', state: { paymentID }
                });
            },
            isMobile() {
                if (screen.width <= 768) {
                    return true;
                }
                else {
                    return false;
                }
            },
            getCaseOrCitation(pastPayment: server.PastPayment) {
                return pastPayment.TicketNumber == null || pastPayment.TicketNumber == "" ? (pastPayment.Court + pastPayment.CaseNo) : pastPayment.TicketNumber
            },
            caseOrCitationSort(a: any, b: any, isAsc: boolean) {
                var aValue = this.getCaseOrCitation(a) as any;
                var bValue = this.getCaseOrCitation(b)as any;

                if (!aValue && aValue !== 0) return 1;
                if (!bValue && bValue !== 0) return -1;
                if (aValue === bValue) return 0;

                aValue = typeof aValue === "string" ? aValue.toUpperCase() : aValue;
                bValue = typeof bValue === "string" ? bValue.toUpperCase() : bValue;

                return isAsc ? (aValue > bValue ? 1 : -1) : aValue > bValue ? -1 : 1;
            }
        },
        mounted() {
            this.getPayments();
        },
    });

